import React from 'react';
import './index.scss';

interface IAddTitlePanelProps {
    removeDialog: () => void;
    confirmCallback: (title: string) => void;
    editCallback: (title: string) => void;
    title: string;
}

const AddTitlePanel = (props: IAddTitlePanelProps) => {
    let TitleValue = '';
    const changeValue = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        TitleValue = e.target.value;
    };
    const cancel = () => {
        props.removeDialog();
    };
    const confirmBtn = () => {
        if (props.title) {
            props.editCallback(TitleValue);
        } else {
            props.confirmCallback(TitleValue);
        }
        props.removeDialog();
    };

    return (
        <div className="title-panel-wrap">
            <div className="panelBox">
                <i
                    className="w-e-icon-close w-e-panel-close"
                    onClick={() => props.removeDialog()}></i>
                <ul className="w-e-panel-tab-title">
                    <li className="w-e-item w-e-active">编辑段落标题</li>
                </ul>
                <div className="w-e-panel-tab-content">
                    <div className="w-e-up-video-container">
                        <textarea
                            name=""
                            id="editTitleTextArea"
                            maxLength={30}
                            autoFocus={true}
                            defaultValue={props.title || ''}
                            onChange={(
                                e: React.ChangeEvent<HTMLTextAreaElement>
                            ) => changeValue(e)}
                            placeholder="添加段落标题（最多30个字）"></textarea>
                        <div className="add-title-bottom-button">
                            <span onClick={() => cancel()}>取消</span>
                            <span onClick={() => confirmBtn()}>确定</span>
                        </div>
                    </div>
                </div>
            </div>
            <div
                className="bigPanelcontainerShade"
                onClick={() => props.removeDialog()}></div>
        </div>
    );
};

export default AddTitlePanel;
